import React, { Fragment, useContext, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

const SlideInContainerStyled = styled.div.attrs({
  className: 'slidein-container',
})`
  ${props => {
    const { theme = {}, darkMode = false, active = false } = props;
    const { colors = {}, fonts = {}, media = {} } = theme;
    return css`
      height: 300px;
      width: 300px;
      position: fixed;
      top: 0;
      right: 0;
      z-index: 999999;
      box-shadow: 1px 0px 7px rgba(0,0,0,0.5); 
      transform: translateX(100%);
      transition: transform 0.3s ease-out;
      background: tan;

      ${active && `
        transform: translateX(0);
      `}
    `;
  }}
`;

const SlideIn = ({ title, ctaText, ctaImage, ctaLink }) => {
  const [isShowing, setIsShowing] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsShowing(true);
    }, 1000);
  }, [])

  const closeSlideIn = () => {
    setIsShowing(false);
  }

  return (
    <SlideInContainerStyled active={isShowing}>
      <h2>{title}</h2>
      <div>{ctaText}</div>
      <div><a title="More Info Button" href={`${ctaLink}`}>More Info</a></div>
      <div style={{cursor: 'pointer', position: 'absolute', top: '8px', right: '20px'}} onClick={closeSlideIn}>X</div>
    </SlideInContainerStyled>
  )
}

export default SlideIn;